import React, {Component} from 'react';
import Dialog from "../dialog";
import Email from "../email";

class NoEvaluation extends Component {

    render() {
        const body =
            <div className="NoEvaluation">
                <p>{'Hodnocení spokojenosti mohou vyplnit jen zákazníci, kteří mají přiřazený hlasovací kód. Zdá se, že vy jste s námi zatím nespolupracovali.'}</p>
                <p>{'Máte zájem o naše služby? Napište nám na:'}</p>
                <Email email={'radbych@aitom.cz'}/>
            </div>;


        return (
            <div className="QuestionForm QuestionForm--center">
                <div className="QuestionForm__body QuestionForm__body--center">
                    <Dialog title={'Bohužel, nemůžete AITOM ohodnotit.'} body={body}/>
                </div>
            </div>
        );
    }

}


export default NoEvaluation;


// WEBPACK FOOTER //
// ./src/components/noEvaluation/index.js